<template>
  <div class="page-content product-list conmon-top">
    <div class="ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="product-search-content">
            <el-form :inline="true" :model="formInlineTmp" class="product-content-item">
              <el-form-item label="商品名称:">
                <el-input v-model="formInlineTmp.name" placeholder="请输入商品名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="兑换范围:">
                <el-select class="special-select" v-model="interestFitValue" multiple placeholder="请选择">
                  <el-option
                    v-for="item in interestFitOptions"
                    :key="item.id"
                    :label="item.level_title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品状态:">
                <el-select v-model="formInlineTmp.status" placeholder="请选择">
                  <el-option
                    v-for="item in productOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">商品列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addProductAction" class="add-btn" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <!-- <el-table-column
          label="序号"
          width="100">
          <template slot-scope="scope">
            <span class="text-grey"> {{ scope.$index + 1}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="pro_code"
          label="商品编码">
        </el-table-column> -->
        <!-- <el-table-column
          width="150"
          label="商品主图">
          <template slot-scope="scope">
            <img :src="scope.row.pic_url" class="table-img">
          </template>
        </el-table-column> -->
        <el-table-column
          prop="name"
          label="商品名称">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.name }}</p>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.name }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="gradeList"
          label="兑换范围">
        </el-table-column> -->
        <el-table-column
          prop="integral"
          label="所需积分">
        </el-table-column>
        <el-table-column
          prop=""
          label="所需金额">
          <template slot-scope="scope">
            {{ scope.row.price / 100 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="stock"
          label="库存">
        </el-table-column>
        <el-table-column
          label="商品状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1" style="color: red" @click="switchChange(scope.row, 0)" class="enable-button">禁用</div>
            <div style="color: green" v-if="scope.row.status === 0" @click="switchChange(scope.row, 1)" class="enable-button">启用</div>
            <!-- <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @click.native="switchChange(scope.row)"
              active-text=""
              inactive-text="">
            </el-switch> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" @click="checkProduct(scope.row.id)">
              查看
            </div>
            <div class="op-link" @click="editProduct(scope.row.id)">
              编辑
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getProductList, changeProductStatus, getMemberLevelList } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
      loading: true,
      interestFitValue: [],
      interestFitOptions: [],
      productOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '禁用',
          value: '0'
        },
        {
          label: '启用',
          value: '1'
        }
      ],
      value: '',
      formInlineTmp: {
        pro_code: '',
        name: '',
        grade_list: '',
        status: ''
      },
      formInline: {
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isSwitchClick: 1,
      memberLevelList: {}
    }
  },
  methods: {
    searchData() {
      this.formInlineTmp.grade_list = this.interestFitValue.toString()
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    checkProduct(Id) {
      router.push({ path: '/home/product-details', query: { id: Id } })
    },
    editProduct(Id) {
      router.push({ path: '/home/edit-product', query: { id: Id } })
    },
    switchChange(row, status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeProductStatus(row.id, status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    addProductAction() {
      router.push('/home/add-product')
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getProductList(this.page, this.formInline).then((res) => {
        if (res.data.code === 0) {
          let array = res.data.data.list
          this.totalCount = res.data.data.total
          for (let item of array) {
            if (item.grade_list.length > 1) {
              item.gradelist = item.grade_list.split(',')
            } else {
              item.gradelist = []
              item.gradelist.push(item.grade_list)
            }
          }
          for (let items of array) {
            items.gradeList = []
            for (let one of items.gradelist) {
              items.gradeList.push(this.memberLevelList[one]) // 取出对应的会员等级名称放入数组 grade_list
            }
            items.gradeList = items.gradeList.toString()
          }
          this.tableData = array
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    getMemberLevel() {
      getMemberLevelList(1, {}).then(res => {
        for (let i in res.data.data.list) {
          let item = res.data.data.list[i]
          this.memberLevelList[item.id] = item.level_title
        }
        this.getData()
      })
    },
    loadMemberLevelList() {
      getMemberLevelList().then(res => {
        for (let item of res.data.data.list) {
          this.interestFitOptions.push({
            id: item.id,
            level_title: item.level_title
          })
        }
      })
    }
  },
  created() {
    this.loadMemberLevelList()
    this.getMemberLevel()
  },
  components: {
  }
}
</script>

<style scoped>
.el-menu-item .menu-btn{
  display:none;float:right;
}
.el-menu-item:hover .menu-btn{
  display: block
}
.name-wrapper{
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}
.enable-button {
  color: #1980FF;
  cursor: pointer;
  font-size: 12px;
}
.product-search-content {
  background-color: #fff;
}
.product-content-item {
  text-align: left;
  margin-left: 35px;
}
.product-search-content .el-form {
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}
.product-search-content .el-form-item {
  margin-bottom: 0px;
}
</style>
